import React from 'react';
import { Button } from 'reactstrap';

import styles from './DataProviderSelector.module.scss';

export default function DataProviderListItem(props) {
  const {
    id,
    logo,
    displayName,
    handleSelection,
    provider,
  } = props;
  return (
    <li>
      <Button
        outline
        className={styles.dataProviderListItem}
        onClick={() => handleSelection(id, provider)}
      >
        <img alt={displayName} className={styles.logo} src={logo} width="60" />
        <span className={styles.label}>
          { displayName }
        </span>
      </Button>
    </li>
  );
}
